<template>
  <ai-customer-iframe type="knowledge" />
</template>

<script>
import AiCustomerIframe from './ai-customer-iframe.vue'

export default {
  name: 'ai-customer-knowledge',
  components: { AiCustomerIframe },
}
</script>
